import React, { useMemo, useState } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
import InfoComponent from './InfoComponent';
import { withStyles, Switch } from '@material-ui/core';

const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});

const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 29,
    height: 16,
    padding: '0 0 2px',
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: '#FFF',
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#2DC38D',
        borderColor: '#2DC38D',
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid white`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#90A4AE',
  },
  checked: {},
}))(Switch);

const TotalUsersChart = ({ title = '', users = {} }) => {
  const [active, setActive] = useState(true);

  const handleActiveSwitch = (event) => setActive(event.target.checked);

  const data = useMemo(() => {
    const fetchChartData = (users) => {
      if (users?.all_users?.total_users) {
        return [
          users?.all_users?.percentage_completed,
          users?.all_users?.percentage_in_progress,
          users?.all_users?.percentage_not_started,
        ];
      } else {
        return [1];
      }
    };

    const colors =
      users?.all_users?.total_users === 0 ? ['#e3e3e3'] : ['#63D2AB', '#F8D783', '#ECEFF1'];

    return {
      labels: ['Completed', 'In Progress', 'Not started'],
      datasets: [
        {
          label: '',
          data: fetchChartData(users),
          backgroundColor: colors,
          borderColor: 'white',
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 3,
        },
      ],
    };
  }, [users]);

  const dataWithoutSkillPaths = useMemo(() => {
    const fetchChartData = (users) => {
      if (users?.mandatory_users?.total_users) {
        return [
          users?.mandatory_users?.percentage_completed,
          users?.mandatory_users?.percentage_in_progress,
          users?.mandatory_users?.percentage_not_started,
        ];
      } else {
        return [1];
      }
    };

    const colors =
      users?.mandatory_users?.total_users === 0 ? ['#e3e3e3'] : ['#607D8B', '#439AD4', '#ECEFF1'];

    return {
      labels: ['Completed', 'In Progress', 'Not started'],
      datasets: [
        {
          label: '',
          data: fetchChartData(users),
          backgroundColor: colors,
          borderColor: 'white',
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 4,
        },
      ],
    };
  }, [users]);

  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1} style={{ padding: '0 10px' }}>
          <span className={styles.headerPeriod}>Progress</span>
          <div className={styles.switchContent}>
            <InfoComponent />
            <CustomSwitch checked={active} onChange={handleActiveSwitch} name="checkedSkillPath" />
          </div>
        </div>
        <div className={styles.cardHeaderLine1} style={{ padding: '0 0 0 10px' }}>
          <span className={styles.headerTitleCopy} style={{ padding: '0' }}>
            {/* {active ? 'Users With Mandatory Skill Path' : 'Users Without Mandatory Skill Path'} */}
          </span>
          <span className={styles.headerPeriod}>In the last year</span>
        </div>
      </div>
      <div className={styles.bodyChart}>
        <Grid container direction="row" spacing={1} alignItems="center" justifyContent="center">
          <Grid item md={6} className={styles.chartDatasets}>
            <ul className="listUnstyled">
              <li className={active ? styles.completed : styles.completedCopy}>
                Completed -{' '}
                <strong>
                  {active
                    ? users?.all_users?.total_users_completed
                    : users?.mandatory_users?.total_users_completed}
                </strong>
              </li>
              <li className={active ? styles.inProgress : styles.inProgressCopy}>
                In Progress -{' '}
                <strong>
                  {active
                    ? users?.all_users?.total_users_in_progress
                    : users?.mandatory_users?.total_users_in_progress}
                </strong>
              </li>
              <li className={styles.yetToStart}>
                Not Started -{' '}
                <strong>
                  {active
                    ? users?.all_users?.total_users_not_started
                    : users?.mandatory_users?.total_users_not_started}
                </strong>
              </li>
            </ul>
          </Grid>
          <Grid item md={6} style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}>
            <div className={styles.totalContainer}>
              <h6 className="heading1">
                {active ? users?.all_users?.total_users : users?.mandatory_users?.total_users}
              </h6>
              <p className="paragraph">Total</p>
              <p className="paragraph">Users</p>
            </div>
            <Doughnut
              data={active ? data : dataWithoutSkillPaths}
              options={options(
                active ? users?.all_users?.total_users : users?.mandatory_users?.total_users
              )}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default TotalUsersChart;
